/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Lifecycle state of a declarative workflow run.
 */
export enum EnumWorkflowRunStatus {
    /**
     * The workflow is actively executing on some replica.
     */
    Running = 0,
    /**
     * The workflow has paused at a Human-in-the-Loop <c>Question</c> action and is waiting
     * for the user's answer. The checkpoint required to resume is stored on the run.
     */
    AwaitingInput = 1,
    /**
     * All actions completed successfully.
     */
    Succeeded = 2,
    /**
     * An action failed or the workflow errored out.
     */
    Failed = 3,
    /**
     * The user or system cancelled the run before it reached a terminal outcome.
     */
    Cancelled = 4,
}
